<template>
	<validation-observer v-bind="$attrs" ref="observer" v-slot="{ invalid }">
		<b-form @submit.prevent="save">
			<b-card no-body :class="flush ? 'border-0' : ''">
				<slot name="header"></slot>

				<b-card-body class="mb-0">
					<!-- <validation-provider
						vid="appeal_type_id"
						name="Appeal Type"
						:rules="{ required: true }"
						v-slot="validationContext"
					>
						 <b-form-group label="Type" label-for="appeal_type_id" label-cols-lg="4">
							<b-form-radio-group
								v-model="entity.appeal_type_id"
								:options="appealTypes"
								:disabled="saving || loadingAppealTypes"
								:state="getValidationState(validationContext)"
								name="appeal_type_id"
								value-field="id"
								text-field="name"
								required="required"
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group> 
					</validation-provider> -->

					<!-- <validation-provider
						vid="appeal_level_id"
						name="Appeal Level"
						:rules="{ required: true }"
						v-slot="validationContext"
					>
						<b-form-group label="Level" label-for="appeal_level_id" label-cols-lg="4">
							<b-form-select
								v-model="entity.appeal_level_id"
								:options="insuranceData"
      							:disabled="saving || !insuranceData || insuranceData.length <= 0"
								:state="getValidationState(validationContext)"
								name="appeal_level_id"
								value-field="id"
      							text-field="id"
								required="required"
								 
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider> -->
			<b-row>
				<b-col md="6">
					<b-form-group label="Level" label-cols-lg="4" v-if="appeal && appeal.id == null">
						<b-input-group>
							<b-form-select v-model="entity.appeal_level_id" :options="insuranceData" value-field="id" text-field="label"  required="required"></b-form-select>
							<template #append>
								<b-button
									variant="success"
									@click="addingInsuranceProvider = !addingInsuranceProvider"
									:active="addingInsuranceProvider"
								>
									<font-awesome-icon icon="plus" fixed-width />
								</b-button>
							</template>
						</b-input-group>
					</b-form-group>
					<b-form-group label="Level" label-cols-lg="4" v-if="appeal && appeal.id !== null">
						<b-input-group>
							<b-form-select v-model="entity.insurance_appeal_id" :options="insuranceDataForEditForm" value-field="id" text-field="label"  required="required" :disabled="entity.is_rebill == true"></b-form-select>
							<template #append>
								<b-button
							    	:disabled="entity.is_rebill == true"
									variant="success"
									@click="addingInsuranceProvider = !addingInsuranceProvider"
									:active="addingInsuranceProvider"
								>
									<font-awesome-icon icon="plus" fixed-width />
								</b-button>
							</template>
						</b-input-group>
					</b-form-group>
				</b-col>
					
					<div v-if="addingInsuranceProvider" class="mb-4">
							<!-- <insurance-provider-form
								@cancel="addingInsuranceProvider = false"
								@saved="addedNewInsuranceProvider"
							>-->
								<!-- <template #header> -->
									<b-card-header>
										<div class="d-flex justify-content-between align-items-center">
											<span class="font-weight-bold">Edit Insurance Provider</span>
											<b-button
												variant="danger"
												size="sm"
												@click="addingInsuranceProvider = false"
												title="Cancel"
												class="mb-0"
											>
												<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
											</b-button>
										</div>
									</b-card-header>
								<!-- </template> -->
							<!-- </insurance-provider-form>  -->
							<EditForm :id="caseEntity.insurance_provider_id"  />
						</div>
					
						
						<!-- <b-col md="6">
					<validation-provider
						vid="letter_date"
						name="Audit Letter Date"
						:rules="{ required: true }"
						v-slot="validationContext"
					>
						<b-form-group label="Audit Letter Date" label-for="letter_date" label-cols-lg="4">
							<b-form-input
								type="date"
								v-model="entity.letter_date"
								name="letter_date"
								required="required"
								:disabled="saving"
								:state="getValidationState(validationContext)"
								:min="minDate"
								:max="today"
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>
				</b-col> -->
				</b-row>
				<b-row>
					<b-col md="6">
						<validation-provider
							vid="letter_date"
							name="Audit Letter Date"
							:rules="{ required: true }"
							v-slot="validationContext"
						>
							<b-form-group label="Audit Letter Date" label-for="letter_date" label-cols-lg="4">
								<b-form-input
									type="date"
									v-model="entity.letter_date"
									name="letter_date"
									required="required"
									:disabled="saving"
									:state="getValidationState(validationContext)"
									 :min="minDate"
									:max="today"
								/>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-form-group>
						</validation-provider>
					</b-col>
					<b-col class="md-6" v-if="!iscontract">
					<validation-provider
						vid="received_date"
						name="Audit Received Date"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Audit Received Date" label-for="received_date" label-cols-lg="4">
							<b-form-input
								type="date"
								v-model="entity.received_date"
								name="received_date"
								:disabled="saving"
								:state="getValidationState(validationContext)"
								:min="entity.letter_date"
								:max="today"
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>
					</b-col>
					<!-- conditional rendering of Received From Facility when facility is a contract facility. -->
					<b-col cols="12" md="6" v-if="caseEntity.facility !== null && iscontract">
						<validation-provider
						
							vid="received_facilitydates"
							name="Received by Facility"
							:rules="{ required: true }"
							v-slot="validationContext"
						>
							<b-form-group label="Received From Facility" label-for="received_facilitydates" label-cols-lg="4">
								<b-form-input
									type="date"
									v-model="entity.received_facilitydate"
									name="received_facilitydates"
									required="required"
									:disabled="saving"
									:state="getValidationState(validationContext)"
									:min="minDate"
									:max="today"
								/>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-form-group>
						</validation-provider>
					</b-col>
					<!--</b-row>
					 <b-col class="md-6" v-if="caseEntity.facility !== null && iscontract">
						<validation-provider
						
							vid="received_facilitydates"
							name="Received by Facility"
							:rules="{ required: false }"
							v-slot="validationContext"
							
						>
							<b-form-group label="Received From Facility" label-for="received_facilitydates" label-cols-lg="4">
								<b-form-input
									type="date"
									v-model="entity.received_facilitydate"
									name="received_facilitydates"
									required="required"
									:disabled="saving"
									:state="getValidationState(validationContext)"
									:min="minDate"
									:max="today"
								/>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-form-group>
						</validation-provider>
				</b-col> 
				</b-row>-->
				<!-- <b-row v-if="caseEntity.facility !== null && iscontract">
					<b-col cols="12" md="6" v-if="caseEntity.facility !== null && iscontract">
						<validation-provider
						
							vid="received_facilitydates"
							name="Received by Facility"
							:rules="{ required: true }"
							v-slot="validationContext"
						>
							<b-form-group label="Received From Facility" label-for="received_facilitydates" label-cols-lg="4">
								<b-form-input
									type="date"
									v-model="entity.received_facilitydate"
									name="received_facilitydates"
									required="required"
									:disabled="saving"
									:state="getValidationState(validationContext)"
									:min="minDate"
									:max="today"
								/>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-form-group>
						</validation-provider>
					</b-col>
				</b-row> -->
				</b-row>
				<!-- <b-col class="md-6" v-if="caseEntity.facility !== null && iscontract">
						<validation-provider
						
							vid="received_facilitydates"
							name="Received by Facility"
							:rules="{ required: false }"
							v-slot="validationContext"
							
						>
							<b-form-group label="Received From Facility" label-for="received_facilitydates" label-cols-lg="4">
								<b-form-input
									type="date"
									v-model="entity.received_facilitydate"
									name="received_facilitydates"
									required="required"
									:disabled="saving"
									:state="getValidationState(validationContext)"
									:min="minDate"
									:max="today"
								/>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-form-group>
						</validation-provider>
				</b-col> 
				</b-row>-->
				<!-- <b-row v-if="caseEntity.facility !== null && iscontract">
					<b-col cols="12" md="6" v-if="caseEntity.facility !== null && iscontract">
						<validation-provider
						
							vid="received_facilitydates"
							name="Received by Facility"
							:rules="{ required: true }"
							v-slot="validationContext"
						>
							<b-form-group label="Received From Facility" label-for="received_facilitydates" label-cols-lg="4">
								<b-form-input
									type="date"
									v-model="entity.received_facilitydate"
									name="received_facilitydates"
									required="required"
									:disabled="saving"
									:state="getValidationState(validationContext)"
									:min="minDate"
									:max="today"
								/>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-form-group>
						</validation-provider>
					</b-col>
				</b-row> -->
				<b-row>
				<b-col class="md-6">	
					<validation-provider
						vid="days_to_decision"
						name="Days to Respond"
						:rules="{ required: true, min: 0, max: 365 }"
						v-slot="validationContext"
					>
						<b-form-group label="Days To Respond" label-for="days_to_respond" label-cols-lg="4" v-if="appeal && appeal.id == null">
							<b-form-input
								name="days_to_respond"
								type="number"
								step="1"
								min="0"
								max="365"
								default="daysToRespond"
								v-model="addAppealDaysToRespond"
								:disabled="saving"
								:state="getValidationState(validationContext)"
								
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>

					<!-- Days to respond for Edit Form -->
					<validation-provider
						vid="days_to_decision"
						name="Days to Respond"
						:rules="{ required: true, min: 0, max: 365 }"
						v-slot="validationContext"
					>
						<b-form-group label="Days To Respond" label-for="days_to_respond" label-cols-lg="4" v-if="appeal && appeal.id !== null">
							<b-form-input
								name="days_to_respond"
								type="number"
								step="1"
								min="0"
								max="365"
								default="daysToRespond"
								:value="entity.days_to_respond ? entity.days_to_respond : entity.insurance_provider_appeal_level.days_to_respond"
								v-model="entity.days_to_respond"
								:disabled="saving"
								:state="getValidationState(validationContext)"
								
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>
					</b-col>
				<!-- <b-col class="md-6">	
					<validation-provider
						vid="days_to_decision"
						name="Days to Decision"
						:rules="{ required: true, min: 0, max: 365 }"
						v-slot="validationContext"
					>
						<b-form-group label="Days to Decision" label-for="days_to_respond" label-cols-lg="4">
							<b-form-input
							    name="days_to_respond"
								type="number"
								step="1"
								min="0"
								max="365"
								default="daysToDecision"
								v-model="selectedDaysToDecision"
								:disabled="saving"
								:state="getValidationState(validationContext)"
								required="required"
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>
				</b-col> -->
				<b-col class="md-6">
					<validation-provider
						vid="Grace Days"
						name="Grace Days"
						:rules="{ required: false, min: 0, max: 365 }"
						v-slot="validationContext"
					>
					<b-form-group label="Grace Days" label-for="Grace Days" label-cols-lg="4" v-if="appeal && appeal.id == null">
							<b-form-input
							    name="grace_days"
								type="number"
								step="1"
								max="365"
								default="Grace Days"
								v-model="addAppealForm_GraceDays"
								@input="updateGraceDays"
								:disabled="saving"
								:state="getValidationState(validationContext)"
								required="required"
	
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>

					<!-- Grace Days for Edit form -->
					<validation-provider
						vid="Grace Days"
						name="Grace Days"
						:rules="{ required: false, min: 0, max: 365 }"
						v-slot="validationContext"
					>
					<b-form-group label="Grace Days" label-for="Grace Days" label-cols-lg="4" v-if="appeal && appeal.id !== null">
							<b-form-input
							    name="grace_days"
								type="number"
								step="1"
								max="365"
								default="Grace Days"
								:value="entity.grace_days ? entity.grace_days : entity.insurance_provider_appeal_level.Grace_days"
								v-model="entity.grace_days"
								@input="updateGraceDays"
								:disabled="saving"
								:state="getValidationState(validationContext)"
								required
	
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>
					</b-col>
				</b-row>

				<b-row>
						<!-- <b-col class="md-6">	
							<validation-provider
								vid="days_to_decision"
								name="Days to Decision"
								:rules="{ required: true, min: 0, max: 365 }"
								v-slot="validationContext"
							>
								<b-form-group label="Days To Respond " label-for="days_to_respond" label-cols-lg="4">
									<b-form-input
										name="days_to_respond"
										type="number"
										step="1"
										min="0"
										max="365"
										default="daysToRespond"
										v-model="selectedDaysToRespond"
										:disabled="saving"
										:state="getValidationState(validationContext)"
										
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>
							</validation-provider>
						</b-col> -->
					
							<b-col class="md-6">	
								<validation-provider
									vid="days_to_decision"
									name="days_to_decision"
									:rules="{ min: 0, max: 365 }"
									v-slot="validationContext"
								>
									<b-form-group label="Days to Decision" label-for="days_to_respond" label-cols-lg="4" v-if="appeal && appeal.id == null">
										<b-form-input
											name="days_to_respond"
											type="number"
											step="1"
											min="0"
											max="365"
											default="daysToDecision"
											:value="selectedDaysToDecision ? selectedDaysToDecision : entity.days_to_decision"
											v-model="entity.days_to_decision"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<!-- Days to decision for edit form -->
								
								<validation-provider
									vid="days_to_decision"
									name="days_to_decision"
									:rules="{ min: 0, max: 365 }"
									v-slot="validationContext"
								>
									<b-form-group label="Days to Decision" label-for="days_to_respond" label-cols-lg="4" v-if="appeal && appeal.id !== null">
										<b-form-input
											name="days_to_respond"
											type="number"
											step="1"
											min="0"
											max="365"
											default="daysToDecision"
											:value="entity.days_to_decision ? entity.days_to_decision : entity.insurance_provider_appeal_level.max_days"
											v-model="entity.days_to_decision"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>
						</b-col>
						<b-col class="md-6" v-if="appeal && appeal.id == null">
							<validation-provider
								vid="due_date"
								name="Audit Due Date"
								:rules="{ required: true}"
								v-slot="validationContext"
							>
								<b-form-group label="Audit Due Date" label-for="due_date" label-cols-lg="4">
									<b-form-input
										type="date"
										v-model="entity.due_date"
										name="due_date"
										required="required"
										:readonly="false"
										:disabled="true"
										:state="getValidationState(validationContext)"
										:min="entity.letter_date"
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>
							</validation-provider>
						</b-col>
						<b-col class="md-6" v-if="appeal && appeal.id !== null">
							<validation-provider
								vid="due_date"
								name="Audit Due Date"
								:rules="{ required: true}"
								v-slot="validationContext"
							>
								<b-form-group label="Audit Due Date" label-for="due_date" label-cols-lg="4">
									<b-form-input
										type="date"
										v-model="entity.due_date"
										name="due_date"
										required="required"
										:readonly="false"
										:disabled="true"
										:state="getValidationState(validationContext)"
										:min="entity.letter_date"
									/>
									<b-form-invalid-feedback
										v-for="error in validationContext.errors"
										:key="error"
										v-text="error"
									/>
								</b-form-group>
							</validation-provider>
						</b-col>
					</b-row>
				<b-row>
					<!-- <validation-provider
						vid="days_to_respond_from"
						name="Days to respond from"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="From" label-for="days_to_respond_from" label-cols-lg="4">
							<b-form-radio-group
								class="mt-2"
								v-model="entity.days_to_respond_from_id"
								:options="daysToRespondFroms"
								:disabled="saving || loadingDaysToRespondFroms"
								:state="getValidationState(validationContext)"
								name="days_to_respond_from"
								value-field="id"
								text-field="name"
								required="required"
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider> -->

				</b-row>
				<b-row>
					<b-col class="md-6">
                    <validation-provider
						vid="agency_id"
						name="Agency"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Agency" label-for="agency_id" label-cols-lg="4">
							<b-input-group>
								<b-form-select
									v-model="entity.agency_id"
									:options="agencies"
									:disabled="saving || loadingAgencies"
									:state="getValidationState(validationContext)"
									name="agency_id"
									value-field="id"
									text-field="name"
									@change="changedAgency"
								>
									<template #first>
										<option :value="null">(None)</option>
										<option :value="null">-- Not Applicable --</option>
									</template>
								</b-form-select>
								<template #append>
									<b-button
										variant="success"
										@click="addingAgency = !addingAgency"
										:active="addingAgency"
									>
										<font-awesome-icon icon="plus" fixed-width />
									</b-button>
								</template>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-input-group>
						</b-form-group>
					</validation-provider>
				</b-col>
				<b-col class="md-6">
					<validation-provider
						vid="audit_reviewer_id"
						name="Audit Reviewer"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Audit Reviewer" label-for="audit_reviewer_id" label-cols-lg="4">
							<b-input-group>
								<b-form-select
									v-model="entity.audit_reviewer_id"
									:options="filteredAuditReviewers"
									:disabled="saving || loadingAuditReviewers"
									:state="getValidationState(validationContext)"
									
									name="audit_reviewer_id"
									value-field="id"
									text-field="full_name"
								>
									<template #first>
										<option :value="null">(None)</option>
									</template>
								</b-form-select>
								<template #append>
									<b-button
										variant="success"
										@click="addingAuditReviewer = !addingAuditReviewer"
										:active="addingAuditReviewer"
									>
										<font-awesome-icon icon="plus" fixed-width />
									</b-button>
								</template>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-input-group>
						</b-form-group>
					</validation-provider>
				</b-col>
			</b-row>
			<div v-if="addingAgency" class="mb-4">
				<agency-form @saved="addedAgency" @cancel="addingAgency = false">
					<template #header>
						<b-card-header>
							<div class="d-flex justify-content-between align-items-center">
								<span class="font-weight-bold">Add New Agency</span>
								<b-button
									variant="danger"
									size="sm"
									@click="addingAgency = false"
									title="Cancel"
									class="mb-0"
								>
									<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
								</b-button>
							</div>
						</b-card-header>
					</template>
				</agency-form>
			</div>
			<b-row>
				<b-col class="md-6">
					<b-form-group
						label="Priority"
						label-for="priority"
						label-cols-lg="4"
						description="This is a high priority audit."
					>
						<b-form-checkbox name="priority" v-model="entity.priority">Priority</b-form-checkbox>
					</b-form-group>
				</b-col>
				<b-col class="md-6">
					<validation-provider
						vid="assigned_to"
						name="Assigned To"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Assigned To" label-for="assigned_to" label-cols-lg="4">
							<b-form-select
								v-model="entity.assigned_to"
								name="assigned_to"
								:options="users"
								:disabled="saving"
								value-field="id"
								text-field="full_name"
							>
								<template #first>
									<option :value="null">(Unassigned)</option>
								</template>
							</b-form-select>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>
					</b-col>
				</b-row>
				<b-row>
				<!-- <b-col class="md-6">
					<validation-provider
						vid="audit_reviewer_id"
						name="Audit Reviewer"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Audit Reviewer" label-for="audit_reviewer_id" label-cols-lg="4">
							<b-input-group>
								<b-form-select
									v-model="entity.audit_reviewer_id"
									:options="filteredAuditReviewers"
									:disabled="saving || loadingAuditReviewers"
									:state="getValidationState(validationContext)"
									
									name="audit_reviewer_id"
									value-field="id"
									text-field="full_name"
								>
									<template #first>
										<option :value="null">(None)</option>
									</template>
								</b-form-select>
								<template #append>
									<b-button
										variant="success"
										@click="addingAuditReviewer = !addingAuditReviewer"
										:active="addingAuditReviewer"
									>
										<font-awesome-icon icon="plus" fixed-width />
									</b-button>
								</template>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-input-group>
						</b-form-group>
					</validation-provider>
				</b-col> -->
					<div v-if="addingAuditReviewer" class="mb-4">
						<audit-reviewer-form @saved="addedAuditReviewer" @cancel="addingAuditReviewer = false">
							<template #header>
								<b-card-header>
									<div class="d-flex justify-content-between align-items-center">
										<span class="font-weight-bold">Add New Audit Reviewer</span>
										<b-button
											variant="danger"
											size="sm"
											@click="addingAuditReviewer = false"
											title="Cancel"
											class="mb-0"
										>
											<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
										</b-button>
									</div>
								</b-card-header>
							</template>
						</audit-reviewer-form>
					</div>

					<!-- <validation-provider
						vid="agency_id"
						name="Agency"
						:rules="{ required: false }"
						v-slot="validationContext"
					>
						<b-form-group label="Agency" label-for="agency_id" label-cols-lg="4">
							<b-input-group>
								<b-form-select
									v-model="entity.agency_id"
									:options="agencies"
									:disabled="saving || loadingAgencies"
									:state="getValidationState(validationContext)"
									name="agency_id"
									value-field="id"
									text-field="name"
								>
									<template #first>
										<option :value="null">(None)</option>
									</template>
								</b-form-select>
								<template #append>
									<b-button
										variant="primary"
										@click="addingAgency = !addingAgency"
										:active="addingAgency"
									>
										<font-awesome-icon icon="plus" fixed-width />
									</b-button>
								</template>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-input-group>
						</b-form-group>
					</validation-provider>

					<div v-if="addingAgency" class="mb-4">
						<agency-form @saved="addedAgency" @cancel="addingAgency = false">
							<template #header>
								<b-card-header>
									<div class="d-flex justify-content-between align-items-center">
										<span class="font-weight-bold">Add New Agency</span>
										<b-button
											variant="secondary"
											size="sm"
											@click="addingAgency = false"
											title="Cancel"
											class="mb-0"
										>
											<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
										</b-button>
									</div>
								</b-card-header>
							</template>
						</agency-form>
					</div> -->

						<!-- <validation-provider
							vid="insurance_provider_id"
							name="Insurance Provider"
							:rules="{ required: false }"
							v-slot="validationContext"
						>
							<b-form-group label="Insurance Provider" label-for="insurance_provider" label-cols-lg="4">
								<b-input-group>
									<b-select
										name="insurance_provider_id"
										v-model="insurance"
										:options="insuranceProviders"
										:disabled="saving || loadingInsuranceProviders"
										:state="getValidationState(validationContext)"
										value-field="id"
										text-field="name"
									>
										<template #first>
											<b-select-option :value="null"> (None) </b-select-option>
										</template>
									</b-select>
									<template #append>
										<b-button
											variant="primary"
											@click="addingInsuranceProvider = !addingInsuranceProvider"
											:active="addingInsuranceProvider"
										>
											<font-awesome-icon icon="plus" fixed-width />
										</b-button>
									</template>
								</b-input-group>
								<b-form-invalid-feedback
									v-for="error in validationContext.errors"
									:key="error"
									v-text="error"
								/>
							</b-form-group>
						</validation-provider>

						<div v-if="addingInsuranceProvider" class="mb-4">
							<insurance-provider-form
								@cancel="addingInsuranceProvider = false"
								@saved="addedNewInsuranceProvider"
							>
								<template #header>
									<b-card-header>
										<div class="d-flex justify-content-between align-items-center">
											<span class="font-weight-bold">Add Insurance Provider</span>
											<b-button
												variant="secondary"
												size="sm"
												@click="addingInsuranceProvider = false"
												title="Cancel"
												class="mb-0"
											>
												<font-awesome-icon icon="remove" fixed-width class="my-0 py-0" />
											</b-button>
										</div>
									</b-card-header>
								</template>
							</insurance-provider-form>
						</div> -->
					

					<!-- <b-card-footer>
						<b-row>
							<b-col cols="12" md="6" xl="4" class="mb-4 mb-md-0">
								<b-button v-if="!disableCancel" block variant="light" @click="cancel">Cancel</b-button>
							</b-col>
							<b-col cols="12" md="6" offset-xl="4" xl="4">
								<b-button
									block
									variant="primary"
									type="submit"
									:disabled="saving || disabled"
									:title="invalid ? 'Please fix any validation errors' : 'Save'"
									@click="buttonPressed"
									>
									<font-awesome-icon icon="circle-notch" v-if="saving" spin fixed-width />
									<span>Save</span>
								</b-button>
							</b-col>
						</b-row>
					</b-card-footer> -->

					
				<b-col class="col-6">
					<validation-provider
						vid="audit_identifier"
						name="Audit ID"
						:rules="{ required: false, max: 100 }"
						v-slot="validationContext"
					>
						<b-form-group
							label="Encore Audit ID"
							label-for="audit_identifier"
							description="A vendor provided reference ID to this appeal"
							label-cols-lg="4"
						>
							<b-form-input
								name="audit_identifier"
								type="text"
								v-model="entity.audit_identifier"
								:disabled="saving"
								:state="getValidationState(validationContext)"
								placeholder="Optional"
							/>
							<b-form-invalid-feedback
								v-for="error in validationContext.errors"
								:key="error"
								v-text="error"
							/>
						</b-form-group>
					</validation-provider>
				</b-col>
				</b-row>
				</b-card-body>
				

				<b-card-body>
				    <!--	<h6 class="text-muted">Optional</h6>-->
					<b-card no-body>
					<!--	<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseHearing
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
								>Hearing</b-button
							>
						</b-card-header>
						<b-collapse id="collapseHearing" role="tabpanel">
							<b-card-body>
								<validation-provider
									vid="hearing_date"
									name="Hearing Date"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Hearing Date" label-for="hearing_date" label-cols-lg="4">
										<b-form-input
											name="hearing_date"
											type="date"
											v-model="entity.hearing_date"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<validation-provider
									vid="hearing_time"
									name="Hearing Time"
									:rules="{ required: false }"
									v-slot="validationContext"
								>
									<b-form-group label="Hearing Time" label-for="hearing_time" label-cols-lg="4">
										<b-form-input
											name="hearing_time"
											type="time"
											v-model="entity.hearing_time"
											:disabled="saving"
											:state="getValidationState(validationContext)"
										/>
										<b-form-invalid-feedback
											v-for="error in validationContext.errors"
											:key="error"
											v-text="error"
										/>
									</b-form-group>
								</validation-provider>

								<b-form-group label="Meeting Type" label-for="meeting_type" label-cols-lg="4">
									<b-form-select
										id="meeting_type"
										v-model="entity.meeting_type"
										:disabled="saving"
									>
										<option value="Location">Location</option>
										<option value="Telephonic">Telephonic</option>
										<option value="Video Conference">Video Conference</option>
									</b-form-select>
								</b-form-group>

								// Render input based on selected Meeting Type 
								<template v-if="entity.meeting_type === 'Location'">
									<b-form-group label="Address" label-for="address" label-cols-lg="4">
										<b-form-input
											id="address"
											v-model="entity.address"
											:disabled="saving"
										/>
									</b-form-group>
								</template>
								<template v-else-if="entity.meeting_type === 'Telephonic'">
									<b-form-group label="Phone Number" label-for="phone_number" label-cols-lg="4">
										<b-form-input
											id="phone_number"
											v-model="entity.phone_number"
											:disabled="saving"
										/>
									</b-form-group>
								</template>
								<template v-else-if="entity.meeting_type === 'Video Conference'">
									<b-form-group label="Conference URL" label-for="conference_url" label-cols-lg="4">
										<b-form-input
											id="conference_url"
											v-model="entity.conference_url"
											:disabled="saving"
										/>
									</b-form-group>
								</template>
								</b-card-body>
								</b-collapse>
							-->
						<b-card-header header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseReferenceNumbers
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
								>Reference Numbers</b-button
							>
						</b-card-header>
						<b-collapse id="collapseReferenceNumbers" role="tabpanel">
							<b-card-body>
								<div class="d-flex">
									<b-button
										variant="light"
										@click="addReferenceNumber"
										:disabled="!canAddReferenceNumber"
										class="ml-auto mb-4 btn btn-outline-success"
									>
										<font-awesome-icon icon="plus" fixed-width />
										<span>Add Reference Number</span>
									</b-button>
								</div>
								<!-- <div v-if="entity.appeal_reference_numbers.length > 0"> -->
								<div v-if="entity.appeal_reference_numbers && entity.appeal_reference_numbers.length > 0">
									<div
										v-for="(refNumber, index) in entity.appeal_reference_numbers"
										:key="index"
										class="mb-2"
									>
										<b-form-group>
											<b-input-group>
												<b-form-select
													v-model="refNumber.reference_number_id"
													:options="referenceNumbers"
													:disabled="saving"
													value-field="id"
													text-field="name"
													required="required"
													placeholder="Label"
												>
													<template
														#first
														v-if="!referenceNumbers || referenceNumbers.length == 0"
													>
														<option
															v-if="!refNumber.reference_number_id"
															value="null"
															disabled
														>
															Select a label
														</option>
														<option v-else value="null" disabled>
															No labels were found
														</option>
													</template>
												</b-form-select>
												<b-form-input
													type="text"
													v-model="refNumber.value"
													:disabled="saving"
													required="required"
													placeholder="Value"
												/>
												<b-input-group-prepend>
													<b-button
														variant="danger"
														@click="removeReferenceNumber(refNumber, index)"
													>
														<font-awesome-icon icon="times" fixed-width />
													</b-button>
												</b-input-group-prepend>
											</b-input-group>
										</b-form-group>
									</div>
								</div>
								<empty-result v-else>
									No reference numbers
									<template #content>
										<p>Reference numbers are used for storing additional appeal details.</p>
									</template>
								</empty-result>
							</b-card-body>
						</b-collapse>
						
						<!-- <b-card-header header-tag="header" role="tab" class="p-0"> -->
						<b-card-header v-if="showLevelFinancialDetails && levelName != 'ADR'" header-tag="header" role="tab" class="p-0">
							<b-button
								block
								v-b-toggle.collapseFinancial
								variant="light"
								role="tab"
								class="text-left px-4 py-3 m-0"
							>
							 Level Financial Details
							</b-button>
						</b-card-header>
						<b-collapse id="collapseFinancial" role="tabpanel" v-model="collapseVisible">
							<b-card-body v-if="showLevelFinancialDetails && levelName != 'ADR'" >				
								<b-row>
								<b-col class="col-6">
									<validation-provider vid="total_claim_amount"
									name="Total Claim Amount" ref="totalClaimAmountValidationProvider"
									:rules="{ required: true, min_value: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Total Claim Amount"  label-for="total_claim_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<!-- <b-form-input name="total_claim_amount" 
												v-model="caseEntity.total_claim_amount" :disabled="is_total_claim_amount_disabled"
												step="0.00" maxlength="10" autocomplete="off"  /> -->
											<b-form-input name="total_claim_amount" 
												v-model="caseEntity.total_claim_amount" 
												:state="getValidationState(validationContext)"
												step="0.00" maxlength="10" autocomplete="off" :readonly="entity.is_rebill" />	
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider> 
								</b-col>
								<b-col class="col-6" v-if="showLevelFinancialDetails">
									<validation-provider vid="initial_denial_amount"
									name="Initial Denial Amount" ref="initialDenialAmountValidationProvider"
									:rules="{ required: true, min_value: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Initial Denial Amount" label-for="initial_denial_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="initial_denial_amount" 
												v-model="caseEntity.disputed_amount" :disabled="saving"
												:state="getValidationState(validationContext)"
												:min="0"
												step="0.00" maxlength="10" autocomplete="off"
												@input="validateTotalClaimAmount"
												/>
												<b v-if="errors.length > 0" style="color:red">{{ errors[0] }}</b>
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
								</b-col>
								<!-- <b-col class="col-6" v-if="showLevelFinancialDetails">
									<validation-provider vid="initial_denial_amount"
									name="Initial Denial Amount"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Initial Denial Amount" label-for="initial_denial_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="initial_denial_amount" 
												v-model="caseEntity.disputed_amount" :disabled="saving"
												step="0.00" maxlength="10" autocomplete="off"  />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
								</b-col> -->
							</b-row>
							<b-row v-if="entity.is_rebill !== true">
								<b-col class="col-6">
									<!-- <validation-provider vid="total_claim_amount"
									name="Total Claim Amount"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Total Claim Amount" label-for="total_claim_amount"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="total_claim_amount" 
												v-model="caseEntity.total_claim_amount" :disabled="is_total_claim_amount_disabled"
												step="0.00" maxlength="10" autocomplete="off"  />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider> -->
								<validation-provider
									vid="disputed_amount"
									name="Level Denial Amount"
									ref="initialDisputedAmountValidationProvider"
									:rules="{ required: true, min_value: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext"
								>
									<b-form-group :label="`${levelName} Denial Amount`" label-for="disputed_amount" label-cols-lg="4" v-if="showLevelFinancialDetails">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input
											name="disputed_amount"
											:value="levelName === 'Level I' ? caseEntity.disputed_amount : entity.disputed_amount"
											@input="handleDisputedAmount"
											:disabled="saving"
											:state="getValidationState(validationContext)"
											:min="0"
											:max="currencyMax"
											step="0.01"
											maxlength="10"
											autocomplete="off"
											:readonly="levelName === 'Level I'"
											/>
											<b v-if="errorsLevel.length > 0" style="color:red">{{ errorsLevel[0] }}</b>
											
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
								</b-col>
							</b-row>
							<b-row v-if="entity.is_rebill !== true">
							<b-col class="md-6">
								<!-- <validation-provider
									vid="disputed_amount"
									name="Disputed Amount"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext"
								>
									<b-form-group label="Audit Denial Amount " label-for="disputed_amount" label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input
												name="disputed_amount"
												type="number"
												v-model="entity.disputed_amount"
												:disabled="saving"
												:state="getValidationState(validationContext)"
												:min="0"
												:max="currencyMax"
												step="0.01"
												maxlength="10"
												autocomplete="off"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-input-group>
									</b-form-group>
								</validation-provider> -->
								<validation-provider v-if="iscontract" vid="contractRiskAmtCal" name="Contract Risk Amount(Calculated)"
									:rules="{ required: false, min_value: 0, max_value: entity.disputed_amount, double: true }"
									v-slot="validationContext">
									<b-form-group label="Contract Risk Amount(Calculated)" label-for="contract_paid_amt_est"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="contractRiskAmtCal" type="number"
												v-model="contractRiskAmtCal" :disabled="saving"
												:state="getValidationState(validationContext)" :min="0" :max="currencyMax"
												step="0.00" maxlength="10" autocomplete="off" readonly />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
							</b-col>
							<b-col class="md-6">
								<!-- <validation-provider
									vid="outstanding_amount"
									name="Outstanding Amount"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext"
								>
									<b-form-group
										label="Outstanding Amount"
										label-for="outstanding_amount"
										label-cols-lg="4"
									>
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input
												name="outstanding_amount"
												type="number"
												v-model="entity.outstanding_amount"
												:disabled="saving"
												:state="getValidationState(validationContext)"
												:min="0"
												:max="currencyMax"
												step="0.01"
												maxlength="10"
												autocomplete="off"
												readonly
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-input-group>
									</b-form-group>
								</validation-provider> -->
								<validation-provider v-if="iscontract" vid="contract_risk_amt_actual"
									name="Reimbursement Amount"
									:rules="{ required: false, min_value: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext">
									<b-form-group label="Contract Risk Amount(Actual)" label-for="contract_risk_amt_actual"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="contract_risk_amt_actual" 
												v-model="entity.contract_risk_amt_actual" :disabled="saving"
												:state="getValidationState(validationContext)" :min="0" :max="entity.disputed_amount"
												step="0.00" maxlength="10" autocomplete="off"  />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
							</b-col>
							
							</b-row>
							<b-row>
							<!-- <b-col class="col-6">
								<validation-provider
									vid="reimbursed_amount"
									name="Reimbursed Amount"
									:rules="{ required: false, min: 0, max_value: currencyMax, double: true }"
									v-slot="validationContext"
								>
									<b-form-group
										label="Reimbursed Amount"
										label-for="reimbursed_amount"
										label-cols-lg="4"
									>
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input
												name="Reimbursed Amount"
												type="number"
												v-model="calculatedReimbursedAmount"
												:disabled="saving"
												:state="getValidationState(validationContext)"
												:min="0"
												:max="currencyMax"
												step="0.01"
												maxlength="10"
												autocomplete="off"
											/>
											<b-form-invalid-feedback
												v-for="error in validationContext.errors"
												:key="error"
												v-text="error"
											/>
										</b-input-group>
									</b-form-group>
								</validation-provider>
							</b-col> -->
							<!-- <b-col class="col-12">
								<validation-provider v-if="iscontract" vid="contract_paid_amt_est" name="Contract Risk Amount(Calculated)"
									:rules="{ required: false, min: 0, max_value: entity.disputed_amount, double: true }"
									v-slot="validationContext">
									<b-form-group label="Contract Risk Amount(Calculated)" label-for="contract_paid_amt_est"
										label-cols-lg="4">
										<b-input-group>
											<b-input-group-prepend is-text>
												<font-awesome-icon icon="dollar-sign" fixed-width />
											</b-input-group-prepend>
											<b-form-input name="contract_paid_amt_est" type="number"
												v-model="entity.contract_paid_amt_est" :disabled="saving"
												:state="getValidationState(validationContext)" :min="0" :max="currencyMax"
												step="0.00" maxlength="10" autocomplete="off" readonly />
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
												v-text="error" />
										</b-input-group>
									</b-form-group>
								</validation-provider>
							</b-col> -->
							</b-row>
							</b-card-body>
						</b-collapse>
						<b-card-header header-tag="header" role="tab" class="p-0" v-if="showLevelFinancialDetails && levelName != 'ADR'">
							<b-button block v-b-toggle.collapseDenial variant="light" role="tab"
								class="text-left px-4 py-3 m-0">
								Audit Denial Details
							</b-button>
						</b-card-header>
						<b-collapse id="collapseDenial" role="tabpanel" v-if="showLevelFinancialDetails && levelName != 'ADR'">
							<b-card-body>
								<b-row>
									<!-- First Column for Denial Type -->
									<b-col cols="12" md="4">
										<validation-provider vid="denial_type_id" name="Denial Type" :rules="{ required: false }" v-slot="validationContext">
										<b-form-group label="Denial Type" label-for="denial_type_id" label-cols-lg="4">
											<b-select name="denial_type_id" v-model="entity.denial_type_id" :options="denialTypes" :disabled="saving || loadingDenialTypes" :state="getValidationState(validationContext)" value-field="id" text-field="name">
											<template #first>
												<option :value="null">(None)</option>
											</template>
											</b-select>
											<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error" v-text="error" />
										</b-form-group>
										</validation-provider>
									</b-col>

									<!-- Second Column for Denial Reason -->
									<b-col cols="12" md="8">
										<div v-if="addingDenialReason">
										<denial-reason-form autofocus @cancel="addingDenialReason = false" @saved="addedNewDenialReason">
											<!-- Your Denial Reason Form Content -->
										</denial-reason-form>
										</div>
										<div v-else>
										<b-form-group label="Denial Reasons" tabindex="1" label-for="denial_reasons" label-cols-lg="2">
											<!-- <denial-reason-search-multi name="denial_reasons" v-model="currentDenialReasons" @add="addingDenialReason = true" :disabled="saving" /> -->
											
											<!-- <b-row class="mt-1" v-if="currentDenialReasons.length">
										
											<b-col sm="12" lg="12">
												<div class="selected-item">
												<div v-if="!currentDenialReasons.length">
													<empty-result>
													No reasons added.
													</empty-result>
												</div>
												<div v-else>
													<h6 class="border_bottom" style="padding-bottom: 14px;">
													Selected reason-
													<span style="float: right;">
														<font-awesome-icon icon="trash" @click.stop="toggleDeleteMode" style="cursor: pointer;" />
													</span>
													</h6>
													<div v-for="(selectedItem, index) in currentDenialReasons" :key="index" class="border_bottom">
													<p>
														<input type="checkbox" v-if="deleteFacilityMode" v-model="selectedItem.checked" />
														<span>
														<font-awesome-icon icon="bars" style="padding-right: 8px;" />{{ selectedItem.name }}
														</span>
													</p>
													</div>
													<div v-if="deleteFacilityMode" style="display: flex; justify-content: space-between; margin-top: 5px;">
													<button @click="cancelFacilityDeleteMode" class="btn btn-secondary btn-sm">Cancel</button>
													<button @click="removeSelectedItems" class="btn btn-danger btn-sm">Remove</button>
													</div>
												</div>
												</div>
											</b-col>
											</b-row>-->
											<b-form-select 
												v-model="currentDenialReasons"
												:options="entities" 
												value-field="id" 
  												text-field="name" 
												:disabled="saving" 
												name="denial_reasons">
											</b-form-select>
										</b-form-group> 
										</div>
									</b-col>
									</b-row>

								
									<!-- Powerback Denial Reason -->
									<!-- <div class="col-lg-8 col-md-9">
										<validation-provider vid="pwrbck_deny_res" name="Powerback Denial Reason" :rules="{ required: false }"
											v-slot="validationContext">
											<b-form-group label="Powerback Denial Reason" label-for="pwrbck_deny_res" label-cols-lg="2">
												<b-select v-model="selectedDenialReason" name="pwrbck_denial_reason"
													:state="getValidationState(validationContext)">
													<template #first>
														<option :value="null">(None)</option>
													</template>
													<option v-for="reason in denialReasons[0]" :key="reason.id" :value="reason.id">
														{{ reason.reason }}
													</option>
												</b-select>
												<b-form-invalid-feedback v-for="error in validationContext.errors" :key="error"
													v-text="error" />
											</b-form-group>
										</validation-provider>
									</div> -->
							
							</b-card-body>

						</b-collapse>


					</b-card>
				</b-card-body>

				<b-card-footer>
					<b-row>
						<b-col cols="12" md="6" xl="4" class="mb-4 mb-md-0">
							<b-button v-if="!disableCancel" block variant="light" @click="cancel" class="btn btn-outline-danger">Cancel</b-button>
						</b-col>
						<b-col cols="12" md="6" offset-xl="4" xl="4">
							<b-button
								block
								variant="light"
								type="submit"
								:disabled="saving"
								:title="invalid ? 'Please fix any validation errors' : 'Save'"
								class="btn btn-outline-primary"
							>
								<font-awesome-icon icon="circle-notch" v-if="saving" spin fixed-width />
								<span>Save</span>
							</b-button>
						</b-col>
					</b-row>
				</b-card-footer>
			</b-card>
		</b-form>
	</validation-observer>
</template>

<script type="text/javascript">
import moment from "moment";
import { mapGetters } from "vuex";
import { formatErrors, getValidationState } from "@/validation";
import { getAbsoluteMinimumDate, getTodaysDate } from "@/shared/helpers/dateHelper";
import AuditReviewerForm from "@/clients/components/AuditReviewers/Form.vue";
import AgencyForm from "@/clients/components/Agencies/Form.vue";
import InsuranceProviderForm from "@/clients/components/InsuranceProviders/Form.vue";
import EditForm from "@/clients/components/InsuranceProviders/Form.vue";
import DenialReasonSearchMulti from "@/clients/components/Search/DenialReasonsMulti.vue";
import DenialReasonForm from "@/clients/components/DenialReasons/Form.vue";
import axios from "axios";


export default {
	name: "AppealForm",
	components: {
		AuditReviewerForm,
		AgencyForm,
		InsuranceProviderForm,
		EditForm,
		DenialReasonSearchMulti,
		DenialReasonForm,
	},
	props: {
		appeal: {
			type: Object,
			default: () => {
				return {
					id: null,
					case_id: null,
					appeal_type_id: null,
					appeal_level_id: null,
					days_to_respond: 30,
					days_to_respond_from_id: null,
					assigned_to: null,
					// letter_date: getTodaysDate(),
					letter_date: null,
					received_date: null,
					due_date: null,
					hearing_date: null,
					hearing_time: null,
					appeal_reference_numbers: [],
					audit_reviewer_id: null,
					agency_id: null,
					priority: null,
					audit_identifier: null,
					received_facilitydate: null,
					outstanding_amount:null,
					disputed_amount:null,
					reimbursed_amount: null,
					denial_type_id:null,
				};
			},
		},
		
		insuranceAppealIdsObject: {
            type: Object,
            required: true,
			default: () => {
				return {
					insuranceAppealIdsObject: {},
				};
			},
        },
		caseEntity: {
			type: Object,
			default: () => {
				return {
					id: null,
					assigned_to: null,
					facility:null,
					facility_id: null,
				};
			},
		},
		referenceLimit: {
			type: Number,
			default: 10,
		},
		flush: {
			type: Boolean,
			default: false,
		},
		disableCancel: {
			type: Boolean,
			default: false,
		},
		currencyMax: {
			type: Number,
			default: 999999999,
		},
	},
	data() {
		return {
			entity: this.appeal,
			loading: true,
			saving: false,
			minDate: getAbsoluteMinimumDate(),
			today: getTodaysDate(),
			addingAuditReviewer: false,
			addingAgency: false,
			addingInsuranceProvider: false,
			letterDate: null,	
			due_date:null,
			insurance:null,
			agency_autofill:null,
			daysToRespond:null,
			daysToDecision:[],
			insuranceData:[],
			// daysToRespond: null,
			gracedays: null,
			// selectedDaysToRespond: [],
			iscontract:null,
			showLevelFinancialDetails:true,
			insurance_provider_id:null,
			insuranceDataForEditForm:[],
			caseData:[],
			contractRiskAmtCal:null,
			addAppealDaysToRespond:null,
			addAppealForm_GraceDays:null,
			is_total_claim_amount_disabled:true,
			// levelName:this.entity.insurance_provider_appeal_level.label || 'Level',,
			addingDenialReason: false,
			currentDenialReasons: null,
			deleteFacilityMode: false,
			insuranceappealid : null,
			insuranceDataLevel: null,
			collapseVisible: false,
			errors: [],
			errorsLevel: [],
		};
		
	},
	computed: {
	selectedDaysToDecision() {
			
			if (!this.entity.appeal_level_id) return null;
			const selectedLevel = this.insuranceData.find(level => {
			return level.id === this.entity.appeal_level_id;
			});
			this.entity.days_to_decision = selectedLevel.max_days;
			this.insuranceappealid = selectedLevel.appeal_level_id;
			return(this.daysToDecision);
		},

		selectedLevel() {
      if (!this.entity.appeal_level_id) return null;
      return this.insuranceData.find(level => level.id === this.entity.appeal_level_id);
    },
    selectedDaysToRespond() {
	return this.selectedLevel ? this.selectedLevel.days_to_respond : null;
    },
 	 	GraceDays() {
			if (!this.entity.appeal_level_id) return null;
			
			const selectedLevel = this.insuranceData.find(level => {
			return level.id === this.entity.appeal_level_id;
			});
			return this.selectedLevel ? this.selectedLevel.Grace_days : null;
  		},

		filteredAuditReviewers() {
			// Assuming auditReviewers is the array containing all audit reviewers
			return this.filterAuditReviewersByAgency(this.entity.agency_id);
		},

		availableAppealLevels() {
			if (
				!this.caseEntity ||
				!this.caseEntity.insurance_provider ||
				!this.caseEntity.insurance_provider.appeal_levels
			) {
				return this.appealLevels;
			}

			if (this.caseEntity.insurance_provider.appeal_levels.length > 0) {
				return this.caseEntity.insurance_provider.appeal_levels;
			}

			return this.appealLevels;
		},
		// dueDate() {
		// 	if (this.entity.days_to_respond && this.entity.days_to_respond_from_id) {
		// 		if (this.entity.days_to_respond_from_id == 1) {
		// 			// received date
		// 			if (this.entity.received_date) {
		// 				return moment(this.entity.received_date)
		// 					.add(this.entity.days_to_respond, "days")
		// 					.format("YYYY-MM-DD");
		// 			} else {
		// 				return null;
		// 			}
		// 		} else if (this.entity.days_to_respond_from_id == 2) {
		// 			// letter date
		// 			if (this.entity.letter_date) {
		// 				return moment(this.entity.letter_date)
		// 					.add(this.entity.days_to_respond, "days")
		// 					.format("YYYY-MM-DD");
		// 			} else {
		// 				return null;
		// 			}
		// 		} else {
		// 			console.error("Invalid days_to_respond_from_id " + this.entity.days_to_respond_from_id);
		// 			return null;
		// 		}
		// 	}
		// 	return null;
		// },
		canAddReferenceNumber() {
			if (!this.entity.appeal_reference_numbers || !this.entity.appeal_reference_numbers.length) {
				return true;
			}

			// Limit number of readmissions
			return this.entity.appeal_reference_numbers.length < this.referenceLimit;
		},
		...mapGetters({
			loadingUsers: "users/loadingActive",
			users: "users/active",
			agencies: "agencies/active",
			loadingAgencies: "agencies/loadingActive",
			appealTypes: "appealTypes/all",
			loadingAppealTypes: "appealTypes/loadingAll",
			auditReviewers: "auditReviewers/active",
			loadingAuditReviewers: "auditReviewers/loadingActive",
			daysToRespondFroms: "daysToRespondFroms/all",
			loadingDaysToRespondFroms: "daysToRespondFroms/loadingAll",
			appealLevels: "appealLevels/all",
			loadingAppealLevels: "appealLevels/loadingAll",
			referenceNumbers: "referenceNumbers/all",
			loadingReferenceNumbers: "referenceNumbers/loadingAll",
			insuranceProviders: "insuranceProviders/active",
			loadingInsuranceProviders: "insuranceProviders/loadingActive",
			denialTypes: "denialTypes/all",
			loadingDenialTypes: "denialTypes/loadingAll",
			entities: "denialReasons/all",
		}),
		levelName() {
			if(this.appeal && this.appeal.id == null){
				let levelName='Level';
				this.insuranceData.forEach((item,index)=>{
					if(this.entity.appeal_level_id===item.id){
						levelName = item.label;
					}
				});
				return levelName;
			}
			else{
				return this.entity?.insurance_provider_appeal_level?.label || 'Level';
			}
    	}
	},
	async mounted() {
		this.fetchData();
		this.getAppealLevelOptions();
		if(this.appeal.id){
			this.fetchDenialTypesAndDenialReasons();
		}
		//this.facilityDetails();
		// this.test();
	
		// let idsToRemove = Object.values(this.insuranceAppealIdsObject).flat();
        // console.log("Extracted IDs from insuranceAppealIdsObject:", idsToRemove);
		// Default appeal type
		if (this.entity.appeal_type_id === null && this.appealTypes.length) {
			this.entity.appeal_type_id = this.appealTypes[0].id;
			
		}

		// Default appeal level
		if (this.entity.appeal_level_id === null && this.appealLevels.length) {
			// this.entity.appeal_level_id = this.appealLevels[0].id;
			
		}

		// Default days to respond from
		if (this.entity.days_to_respond_from_id === null && this.daysToRespondFroms.length) {
			this.entity.days_to_respond_from_id = this.daysToRespondFroms[0].id;
			
		}

		// Default assigned_to
		if (this.entity.assigned_to === null && this.caseEntity.assigned_to) {
			this.entity.assigned_to = this.caseEntity.assigned_to;
			
		}

		if (this.users.length <= 0) {
			this.$store.dispatch("users/getActive");
			
		}
		
		// for calling autofillform function during mounting phase for autofilling the form
		//if(true){
		//	this.autoFillForm();
		//}
	},
	methods: {
		calculatedReimbursedAmount() {
      // Calculate the difference and return it
      return this.entity.disputed_amount - this.entity.outstanding_amount;
    },
	dueDate() {
	let daysToRespond;
	if(this.appeal.id !== null) {
		daysToRespond = this.entity.days_to_respond;
	} else {
		 daysToRespond = this.addAppealDaysToRespond;
	}
    
    let graceDays = this.entity.grace_days || this.addAppealForm_GraceDays;
    
    let startDate;
    
    // Choose the correct start date based on days_to_respond_from_id
    if (this.entity.days_to_respond_from_id === 1) {
      // If days_to_respond_from_id is 1, use the received_date
      startDate = moment(this.entity.received_date);
    } else if (this.entity.days_to_respond_from_id === 2) {
      // If days_to_respond_from_id is 2, use the letter_date
      startDate = moment(this.entity.letter_date);
    }
	startDate = moment(this.entity.letter_date);
	
    if (startDate.isValid()) {
      this.entity.due_date = startDate
        .add(daysToRespond, 'days')
        .add(graceDays, 'days')
        .format('YYYY-MM-DD');
     
    } else {
      this.entity.due_date = null; // Handle invalid date
    }
  },

  recalculate() {
    this.dueDate(); // Force the due date recalculation
  },

		validateTotalClaimAmount() {
			
			const disputedAmount = Number(this.caseEntity.disputed_amount);
			const totalClaimAmount = Number(this.caseEntity.total_claim_amount);
			this.errors = [];
    		if (disputedAmount > totalClaimAmount) {
			this.errors.push('Initial Denial Amount must be less than or equal to the Total Claim Amount.');
			return false;
    		
		} else {
			// Clear any previous errors
      		this.errors = [];
      		return true;
    	}
  		},
		updateAppealLevel() {
			// update appeal level
			
		},
		handleDisputedAmount(value) {

			if (this.levelName !== 'Level I') {
			this.entity.disputed_amount = value;
			}
			const disputedAmount = Number(this.entity.disputed_amount);
			const totalClaimAmount = Number(this.caseEntity.total_claim_amount);
			this.errors = [];
    		if (disputedAmount > totalClaimAmount) {
			this.errorsLevel.push('Level Denial Amount must be less than or equal to the Total Claim Amount.');
			return false;
    		
		} else {
			// Clear any previous errors
      		this.errorsLevel = [];
      		return true;
    	}
			
		},

		getValidationState,
		cancel() {
			this.$emit("cancel");
			this.reset();
		},
		async save(e) {
			//this.saving = true;
			var appealsLen = this.caseData.appeals.length;
			if(this.entity.id){
				this.entity.appeal_level_id = this.entity.insurance_appeal_id;
			}
			const disputedAmountToSaveVal=
                    this.levelName === 'Level I' ? this.caseEntity.disputed_amount : this.entity.disputed_amount;
			if(this.caseEntity.total_claim_amount == null || this.caseEntity.disputed_amount == null || disputedAmountToSaveVal == null)
			{
			this.collapseVisible = true;
			}
			const disputedAmount = Number(this.caseEntity.disputed_amount);
			const leveldisputedAmount = Number(this.entity.disputed_amount);
			const totalClaimAmount = Number(this.caseEntity.total_claim_amount);
			if(totalClaimAmount<disputedAmount) {
			this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",
						message: "Initial Denial Amount must be less than or equal to the Total Claim Amount.",
						title: `Error`,
					});
				});
			 return false;
			}
			if(totalClaimAmount<leveldisputedAmount) {
			this.$nextTick(function () {
					this.$store.dispatch("notify", {
						variant: "danger",
						message: "Level Denial Amount must be less than or equal to the Total Claim Amount.",
						title: `Error`,
					});
				});
			 return false;
			}
			let isValidtotalClaimAmountValidation = true;
			let isValidinitialDenialAmountValidation = true;
			let isValidinitialDisputedAmountValidation = true;
			// Validate 'Total Claim Amount' validation provider
			if (this.$refs.totalClaimAmountValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const totalClaimAmountValidationProviderResult = await this.$refs.totalClaimAmountValidationProvider.validate();
					isValidtotalClaimAmountValidation = totalClaimAmountValidationProviderResult.valid && isValidtotalClaimAmountValidation;
				}
            	
			} else {
				console.error("Admit date validation provider reference is not defined.");
			}
			// Validate 'Initial Denial Amount' validation provider
			if (this.$refs.initialDenialAmountValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const initialDenialAmountValidationProviderResult = await this.$refs.initialDenialAmountValidationProvider.validate();
					isValidinitialDenialAmountValidation = initialDenialAmountValidationProviderResult.valid && isValidinitialDenialAmountValidation;
				}
            	
			} else {
				console.error("Admit date validation provider reference is not defined.");
			}
			// Validate 'Initial Denial Amount' validation provider
			if (this.$refs.initialDisputedAmountValidationProvider) {
				this.triggereValidation = true;
				if(this.triggereValidation){
					const initialDisputedAmountValidationProviderResult = await this.$refs.initialDisputedAmountValidationProvider.validate();
					isValidinitialDisputedAmountValidation = initialDisputedAmountValidationProviderResult.valid && isValidinitialDisputedAmountValidation;
				}
            	
			} else {
				console.error("Admit date validation provider reference is not defined.");
			}

			
			if (isValidtotalClaimAmountValidation && isValidinitialDenialAmountValidation && isValidinitialDisputedAmountValidation) {
			if( appealsLen ==0 || 
			(appealsLen >0 && (this.caseData.appeals[appealsLen-1].appeal_status == "Closed" || 
			this.caseData.appeals[appealsLen-1].id == this.entity.id
			))) {
				
				try {
					this.saving = true;
					let selectedLevell = this.insuranceDataLevel.find(level => {
						if(level.id === this.entity.appeal_level_id) {
							return level.appeal_level_id;
						}
					});
					const calculatedReimbursedAmount = this.calculatedReimbursedAmount;
					const disputedAmountToSave =
                    this.levelName === 'Level I' ? this.caseEntity.disputed_amount : this.entity.disputed_amount;
					const response = await this.$store.dispatch("appeals/save", {
						id: this.entity.id || null,
						case_id: this.entity.case_id || this.caseEntity.id,
						appeal_type_id: this.entity.appeal_type_id,
						// appeal_level_id: this.entity.appeal_level_id,
						appeal_level_id: selectedLevell.appeal_level_id,
						insurance_appeal_id:this.entity.appeal_level_id,
						days_to_respond: this.addAppealDaysToRespond ? this.addAppealDaysToRespond : this.entity.days_to_respond,
						days_to_respond_from_id: this.entity.days_to_respond_from_id,
						letter_date: this.entity.letter_date,
						received_date: this.entity.received_date,
						due_date: this.entity.due_date,
						hearing_date: this.entity.hearing_date,
						hearing_time: this.entity.hearing_time,
						assigned_to: this.entity.assigned_to,
						appeal_reference_numbers: this.entity.appeal_reference_numbers,
						audit_reviewer_id: this.entity.audit_reviewer_id,
						agency_id: this.entity.agency_id,
						audit_identifier: this.entity.audit_identifier,
						priority: this.entity.priority,
						received_facilitydate: this.entity.received_facilitydate,
						disputed_amount:disputedAmountToSave,
						// reimbursed_amount:calculatedReimbursedAmount,
						outstanding_amount:this.entity.outstanding_amount,
						contract_risk_amt_actual:this.entity.contract_risk_amt_actual,
						contract_risk_Amt_Cal:this.contractRiskAmtCal,
						grace_days:this.entity.grace_days,
						days_to_decision:this.entity.days_to_decision
					});
					const responseCaseEnity = await this.$store.dispatch("cases/save", 
					{
						id:this.caseEntity.id,
						total_claim_amount:this.caseEntity.total_claim_amount,
						disputed_amount:this.caseEntity.disputed_amount
					});
					if(this.showLevelFinancialDetails && this.entity.denial_type_id != null && this.currentDenialReasons != null ){
						const saveDenialTypeAndDenialReasonResponse = await axios.post('/client/api/addDenialTypeAndDenialReasonForAppeal', {
							'denial_type_id' : this.entity.denial_type_id,
							'denial_reason_id' : this.currentDenialReasons,
							'appeal_id':response.id,
							'case_id':response.case_id
						});
					}
					
					this.saving = false;
					this.$emit("saved", response);
				} catch (e) {
				
					if (e.response.data.errors) {
						this.$refs.observer.setErrors(formatErrors(e.response.data.errors));
					}

					this.$store.dispatch("apiError", {
						error: e,
						title: "Save Failed",
						message: e.response ? e.response.data.message : "An error occurred while saving the appeal. Please try again."
					});
				} finally {
					this.saving = false;
					this.fetchData();
				}
			}
			else{
				this.$store.dispatch("apiError", {
						error:  500,
						title: "Save Failed",
						message: "Close existing level before creating a new one.",
					});
				this.saving = false;
			}
		} else {
			
		}
		},
		addReferenceNumber() {
			this.entity.appeal_reference_numbers.push({});
		},
		removeReferenceNumber(refNumber, index) {
			this.entity.appeal_reference_numbers.splice(index, 1);
		},
		reset() {
			this.entity = {
				appeal_type_id: null,
				appeal_level_id: null,
				days_to_respond: null,
				days_to_respond_from_id: null,
				assigned_to: null,
				letter_date: null,
				received_date: null,
				due_date: null,
				audit_reviewer_id: null,
				agency_id: null,
				hearing_date: null,
				hearing_time: null,
				appeal_reference_numbers: [],
				priority: null,
				audit_identifier: null,
				days_to_decision:null,
				grace_days:null
			};
		},
		addedAuditReviewer(auditReviewer) {
			this.addingAuditReviewer = false;
			this.entity.audit_reviewer_id = auditReviewer.id;
			this.$store.dispatch("auditReviewers/getActive");
		},
		filterAuditReviewersByAgency(agencyId) {
        // Assuming auditReviewers is the array containing all audit reviewers
        return this.auditReviewers.filter((ar) => ar.agency_id === agencyId);
		},
		changedAgency(value) {
		// Assuming entity is the object representing your form data
		this.entity.agency_id = value;

		// Filter audit reviewers based on the selected agency
		this.filteredAuditReviewers = this.filterAuditReviewersByAgency(value);
		}, 

		// changedAuditReviewer(value) {
			// 	const auditReviewer = this.auditReviewers.find((ar) => ar.id === value);
			// 	if (auditReviewer && auditReviewer.id) {
				// 		this.entity.agency_id = auditReviewer.agency_id ?? null;
			// 	}
		// },
		addedAgency(agency) {
			this.addingAgency = false;
			this.entity.agency_id = agency.id;
			this.$store.dispatch("agencies/getActive");
		},
		addedNewInsuranceProvider(insuranceProvider) {
			this.$store.dispatch("insuranceProviders/getActive");
			this.addingInsuranceProvider = false;
			this.entity.insurance_provider_id = insuranceProvider.id;
		},

		// formatDate(dateString) {
		// 	const date = new Date(dateString);
		// 	const year = date.getFullYear();
		// 	const month = String(date.getMonth() + 1).padStart(2, '0');
		// 	const day = String(date.getDate()).padStart(2, '0');
		// 	return `${year}-${month}-${day}`;
		// },

		// addDaysToDate(dateString, days)
		//  {
		// 	const date = new Date(dateString);
		// 	date.setDate(date.getDate() + days);
		// 	return date.toISOString().split('T')[0];
		// },

		// async autoFillForm() {
		// 	try{
		// 		const url = "http://localhost:8765/client/textract";
				
		// 		const responses = await axios.get(url, {
		// 		headers: {
		// 			"Accept": "application/json",
		// 			// You can add other headers here if needed
		// 		},
		// 		});
		// 		this.daysToRespond =  45;
		// 		this.letterDate = this.formatDate('09/08/2023');  
		// 		this.due_date = this.addDaysToDate(this.letterDate , this.daysToRespond);
		// 		// this.insurance = responses.data[0].insurance_provider; 
		// 		// this.insuranceProviders.unshift(this.insurance);
		// 		this.agency_autofill = 'Performant';
		// 		this.agencies.unshift(this.agency_autofill);
				
				
		// 	} 
		// 	catch (error) {
		// 		console.error("Error:", error);
		// 	}
    	// },

		async buttonPressed() {
				
				const data = {'id':this.entity.assigned_to}

				// Use Axios to make the request to the controller for sending user_id 
			
				const resp = await axios.post('/client/sendemail', data);
				
		},
		// async test(){
		// 	try {
		// 		const url = "/client/insuranceappeal";
				
		// 		const response = await axios.get(url, {
		// 		headers: {
		// 			"Accept": "application/json",
		// 			// You can add other headers here if needed
		// 		},
		// 		});
		// 		// Handle the response data here
		// 		// this.insuranceData = response.data;
		// 		let count =1 ;
		// 		response.data.forEach((item, index) => {
		// 		console.log(`Element at index ${index}:`, item);
		// 		if(item.insurance_provider_id==this.caseEntity.insurance_provider_id){
		// 			console.log("match found = ", item);
		// 			let ids = parseInt(item.id, 10);
		// 			this.insuranceData.push({label:item.label, id:ids , count:count , days_to_respond: item.days_to_respond, Grace_days: item.Grace_days, days_to_decision: item.max_days});
		// 			count ++;
		// 		}
		// 		});
		// 		this.insuranceData.sort((a,b)=> a.id - b.id);
        //         response.data.forEach((item, index) => {
		// 		console.log(`Element at index ${index}:`, item);
		// 		if(item.insurance_provider_id==this.caseEntity.insurance_provider_id){
		// 			console.log("match found");
		// 			this.daysToRespond.push({daysToRespond:item.days_to_respond, id:item.id});
		// 			count ++;
		// 		}
		// 		});
        //         console.log("daysTorespond = " , this.daysToRespond);
		// 		console.log("response updated = " , this.insuranceData);
		// 		console.log("case entity =", this.caseEntity);
		// 		console.log("appeal =", this.entity.appeal_level_id);
		// 		} 
		// 	catch (error) {
		// 		console.error(error);
		// 	}

		// },

		async getAppealLevelOptions(){
			try {
				const url = '/client/appealLevelOptions'
				const response = await axios.post(url, {
					'insurance_provider_id':this.caseData.insurance_provider_id,
					'case_id':this.caseData.id
				});	
				this.insuranceData = response.data.data;
				this.insuranceDataLevel =  response.data.allAppealLevelOptions;
				// Filter insuranceData based on appeals
				const filteredInsuranceData = this.insuranceData.filter((insurance) => {
					// Loop through caseEntity.appeals to check conditions
					for (const obj of this.caseEntity.appeals) {
						// If is_rebill is false, filter out the matching insurance_appeal_id
						if (!obj.is_rebill && obj.insurance_appeal_id === insurance.id) {
							return false; // Exclude this insurance item
						}
					}
					return true; // Keep this insurance item
				});

				// Update the insuranceData with the filtered data
				// this.insuranceData = filteredInsuranceData;
			} catch (error) {
				console.error("Failed in fetching Level Options :",error);
			}
		},
		async test() {
    try {
        const url = "/client/insuranceappeal";

        const response = await axios.get(url, {
            headers: {
                "Accept": "application/json",
                // You can add other headers here if needed
            },
        });

        let count = 1;

        response.data.forEach((item, index) => {
            
            if (item.insurance_provider_id == this.insurance_provider_id) {
              
                let ids = parseInt(item.id, 10);

                // Check if the id is not in insuranceAppealIdsObject before pushing
                // if (!Object.values(this.insuranceAppealIdsObject).flat().includes(ids)) {
                //     this.insuranceData.push({
                //         label: item.label,
                //         id: ids,
                //         count: count,
                //         days_to_respond: item.days_to_respond,
                //         Grace_days: item.Grace_days,
                //         days_to_decision: item.max_days,
				// 		level_type:item.level_type,
                //     });
                //     count++;
                // }
				this.insuranceDataForEditForm.push({
                        label: item.label,
                        id: ids,
                        count: count,
                        days_to_respond: item.days_to_respond,
                        Grace_days: item.Grace_days,
                        days_to_decision: item.max_days,
						level_type:item.level_type,
                    });
                count++;
            }
        });
	
        this.insuranceData.sort((a, b) => a.id - b.id);

		// this.caseData.appeals.forEach((item, index) => {
		// 	console.log("item.insurance_appeal_id = ",item.insurance_appeal_id);
		// 	console.log("this.insurance_appeal_id = ",this.entity.insurance_appeal_id);
		// 	if (item.insurance_appeal_id == this.entity.insurance_appeal_id) {
		// 		console.log('Skipping iteration');
		// 		return; // Skip this iteration
		// 	}

		// 	this.insuranceDataForEditForm = this.insuranceDataForEditForm.filter((insData) => {
		// 		return item.insurance_appeal_id !== insData.id;
		// 	});
		// });
		// Check if caseData and appeals are defined and are arrays
		if (this.caseData && Array.isArray(this.caseData.appeals)) {
			this.caseData.appeals.forEach((item, index) => {
			
				if (item.insurance_appeal_id == this.entity.insurance_appeal_id) {
					
					return; // Skip this iteration
				}

				// Check if insuranceDataForEditForm is defined and is an array
				if (this.insuranceDataForEditForm && Array.isArray(this.insuranceDataForEditForm)) {
					this.insuranceDataForEditForm = this.insuranceDataForEditForm.filter((insData) => {
						return item.insurance_appeal_id !== insData.id;
					});
				} else {
					console.error("insuranceDataForEditForm is undefined or not an array");
				}
				// if (this.insuranceData && Array.isArray(this.insuranceData)) {
				// 		this.insuranceData = this.insuranceData.filter((insData) => {
				// 		return item.insurance_appeal_id !== insData.id;
				// 	});
				// } else {
				// 	console.error("insuranceData is undefined or not an array");
				// }
			});
		}

		this.insuranceDataForEditForm.sort((a, b) => a.id - b.id);
		

        // response.data.forEach((item, index) => {
        //     console.log(`Element at index ${index}:`, item);
        //     if (item.insurance_provider_id == this.caseEntity.insurance_provider_id) {
        //         console.log("match found");
        //         this.daysToRespond.push({ daysToRespond: item.days_to_respond, id: item.id });
        //         count++;
        //     }
        // });

    } catch (error) {
        console.error(error);
    }
},
		updateAppealLevelCount(){
			const selectedOption = this.insuranceData.find(option => option.id === this.entity.appeal_level_id);
			if (selectedOption) {
				this.entity.appeal_level_id = selectedOption.count;
			} else {
				this.entity.appeal_level_id = null; // Handle the case where no option is selected
			}
		
		},
		async facilityDetails(){
            const url = "/client/facilityList";
			
			const response = await axios.get(url, {
			headers: {
				"Accept": "application/json",
				// You can add other headers here if needed
			},
			});
			this.facilities = response.data; // save all facilities for later use
     
	  const filteredFacilities = this.facilities.filter(facility => facility.id === this.caseEntity.facility_id);

  
		if (filteredFacilities) {
		this.iscontract = filteredFacilities.has_contract;
		this.facilitie_name = filteredFacilities.name;
      }
		},
		async fetchData() {
		try {
			// const response = await this.$store.dispatch("cases/get", {
			// 				id: this.$route.params.id,
			// 			});
			const response = await this.$store.dispatch("cases/get", {
							id: this.caseEntity.id,
						});
			this.caseData = response;
			this.carryForwardLastAppealLevelAuditDenialTypesAndAuditDenialDetails();
			const totalClaimAmount = response.total_claim_amount;
			
			this.insurance_provider_id = response.insurance_provider_id;
			
			// this.appeal.disputed_amount = totalClaimAmount;
			this.test();
			this.iscontract = response.facility.has_contract;

			// Checking is the case already has an appeal; Using the last appeal-> outstanding amt in current appeal -> disputed amt
			//Sorting appeals array based on appeal->id
			this.caseData.appeals.sort((a, b) => a.id - b.id);
			if((this.appeal && this.appeal.id == null) && this.caseData.appeals.length > 0){
				const lastAppeal = this.caseData.appeals[this.caseData.appeals.length - 1];
				this.entity.disputed_amount = lastAppeal.outstanding_amount;
			}
			this.getAppealLevelOptions();
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	},
    updateDaysToRespond(newValue) {
      // Do something with newValue if needed
   
      // Update your data property accordingly
      this.daysToRespond = newValue;
    },
	updateGraceDays(newValue) {
     
      this.gracedays = newValue;
	  this.entity.grace_days=newValue;
    },
	calAuditDueDate(){

	},
		control_total_claim_amount_disable(){
			/*
			***
			1. Check if the appeal form is add form or edit form
			2. Handle the workflow based on the form
			3. Check if level is ADR or not
			4. Handle the disabled condition based on the form
			***
			*/
			this.is_total_claim_amount_disabled = true;
			if(this.appeal && this.appeal.id == null){
				
				//Appeal form is add form
				if(this.entity.appeal_level_id==null){
					
					this.is_total_claim_amount_disabled = true;
				}
				this.insuranceData.forEach((item,index)=>{
					if(item.label==='ADR' && this.entity.appeal_level_id===item.id){
						
						this.is_total_claim_amount_disabled = false;
					}
				});
			}
			else{
				//Appeal form is edit form
				
				if(this.entity.insurance_appeal_id==null){
					this.is_total_claim_amount_disabled = true;
				}
				this.insuranceDataForEditForm.forEach((item,index)=>{
					if(item.label==='ADR' && this.entity.insurance_appeal_id===item.id){
						this.is_total_claim_amount_disabled = false;
					}
				});
			}
		},
		addedNewDenialReason(denialReason) {
			this.addingDenialReason = false;
			
			this.currentDenialReasons.push(denialReason);
			this.currentDenialReasons1 = [];
		},
		toggleDeleteMode() {
			this.deleteFacilityMode = !this.deleteFacilityMode;
		},
		cancelFacilityDeleteMode(){
			this.currentDenialReasons.forEach((item) => (item.checked = false));
			this.deleteFacilityMode = false;
		},
		removeSelectedItems() {
			this.currentDenialReasons = this.currentDenialReasons.filter((item) => !item.checked);
			this.deleteFacilityMode = false; // Turn off delete mode after removing items
		},
		async fetchDenialTypesAndDenialReasons(){
			const resp = await axios.post('/client/api/getDenialTypeAndDenialReasonForAppeal', {
					'appeal_id':this.appeal.id
			});
			this.entity.denial_type_id = resp.data.denial_type_id;
			this.currentDenialReasons = resp.data.denial_reason_id;
		},
		async carryForwardLastAppealLevelAuditDenialTypesAndAuditDenialDetails(){
			if(this.caseData.appeals.length > 0){
			const resp = await axios.post('/client/api/getAllDenialTypeAndDenialReasonForAppeal', {
					'case_id':this.caseData.id
			});
			let respLen = resp.data.length;
			this.entity.denial_type_id = resp.data[respLen-1].denial_type_id;
			this.currentDenialReasons = resp.data[respLen-1].denial_reason_id;
			}
		}
	},
	watch: {
		'entity.appeal_level_id': function(newValue, oldValue) {
			this.control_total_claim_amount_disable();
			this.addAppealDaysToRespond = this.selectedLevel ? this.selectedLevel.days_to_respond : null;
			const selectedLevel = this.insuranceData.find(level => {
			return level.id === this.entity.appeal_level_id;
			});
		
			
			// console.log("final",this.gracedays);
			this.addAppealForm_GraceDays = this.selectedLevel ? this.selectedLevel.Grace_days : null;
			let conditionMet = false;
			this.insuranceData.forEach((item) => {
				if (newValue === item.id) {
					if (item.level_type === "Pre-Appeal") {
						this.showLevelFinancialDetails = false;
						conditionMet = true;
						return;
					}
				}
			});

			if (conditionMet) return;
			this.showLevelFinancialDetails = true;
			
			

		},
		// 'GraceDays':function(newValue , oldValue){
		// 	this.dueDate();
		// },
		// 'selectedDaysToRespond':function(newValue , oldValue){
		// 	this.dueDate();
		// },
		'entity.insurance_provider_appeal_level.days_to_respond': function(newValue, oldValue) {
        // Your logic here
       
		this.entity.days_to_respond = newValue;
    	},
		'entity.insurance_provider_appeal_level.label': function(newValue, oldValue) {
        // Your logic here
        
		this.entity.appeal_level_id = this.entity.insurance_provider_appeal_level.id;
    	},
		'entity.insurance_appeal_id': function(newValue, oldValue) {
        // Your logic here
		this.entity.appeal_level_id = this.entity.insurance_appeal_id;
		this.control_total_claim_amount_disable();
		
    	},
		'caseData': function(newValue, oldValue) {
        // Your logic here
		// this.contractRiskAmtCal = (this.entity.disputed_amount * (this.caseData.facility.contract_pricing_schedules[this.caseData.insuranceRateType - 1]))/100;
		const disputedAmount = parseFloat(this.entity.disputed_amount);
		const insuranceRateIndex = this.caseData.insuranceRateType;
	
		const pricingSchedule = parseFloat(this.caseData.facility.contract_pricing_schedules[insuranceRateIndex].contract_rate);
		// console.log("pricing sche = ", this.caseData.facility.contract_pricing_schedules.insuranceRateIndex.contract_rate);

		if (!isNaN(disputedAmount) && !isNaN(pricingSchedule)) {
			this.contractRiskAmtCal = (disputedAmount * pricingSchedule) / 100;
			
		} else {
			
		}
		
		this.caseData.appeals.sort((a, b) => a.id - b.id);
		
    	},
		'entity.disputed_amount': function(newValue, oldValue) {
        // Your logic here
		// this.contractRiskAmtCal = (this.entity.disputed_amount * (this.caseData.facility.contract_pricing_schedules[this.caseData.insuranceRateType - 1]))/100;
		const disputedAmount = parseFloat(this.entity.disputed_amount);
		const insuranceRateIndex = this.caseData.insuranceRateType - 1;
		
		const pricingSchedule = parseFloat(this.caseData.facility.contract_pricing_schedules[insuranceRateIndex].contract_rate);
		// console.log("pricing sche = ", this.caseData.facility.contract_pricing_schedules.insuranceRateIndex.contract_rate);

		if (!isNaN(disputedAmount) && !isNaN(pricingSchedule)) {
			this.contractRiskAmtCal = (disputedAmount * pricingSchedule) / 100;
			
		} else {
			
		}
	
    	},
		'caseEntity.disputed_amount': function(newValue, oldValue) {
		 // Your logic here
		if(this.levelName === 'Level I') {
		// this.contractRiskAmtCal = (this.entity.disputed_amount * (this.caseData.facility.contract_pricing_schedules[this.caseData.insuranceRateType - 1]))/100;
		const disputedAmount = parseFloat(this.caseEntity.disputed_amount);
		const insuranceRateIndex = this.caseData.insuranceRateType - 1;
	
		const pricingSchedule = parseFloat(this.caseData.facility.contract_pricing_schedules[insuranceRateIndex].contract_rate);
		// console.log("pricing sche = ", this.caseData.facility.contract_pricing_schedules.insuranceRateIndex.contract_rate);

		if (!isNaN(disputedAmount) && !isNaN(pricingSchedule)) {
			this.contractRiskAmtCal = (disputedAmount * pricingSchedule) / 100;
			
		} else {
			
		}
		
	}
    	},
'entity.days_to_respond': function(newValue, oldValue) {
    
    this.dueDate();  
  },
  'entity.grace_days': function(newValue, oldValue) {
   
    this.dueDate();  
  },

'addAppealDaysToRespond': function(newValue, oldValue) {
  
    this.dueDate();
  },
  'addAppealForm_GraceDays': function(newValue, oldValue) {
   
    this.dueDate();
  },
  'entity.letter_date': function(newValue, oldValue) {
   
    this.dueDate();
  },
  'entity.days_to_respond_from_id': function(newValue, oldValue) {
   
    this.dueDate(); 
  },
  'entity.insurance_provider_appeal_level.days_to_respond': function(newValue, oldValue) {
   
    this.dueDate();
  },
  'entity.insurance_provider_appeal_level.Grace_days': function(newValue, oldValue) {
    
    this.dueDate();
  }
	}
};
</script>